export default "__VITE_ASSET__DLv0Sd99__"